import { DeliveryAddressModel } from "./DeliveryAddressModel";
import { DeviceCategoryModel } from "./DeviceCategoryModel";
import { DeviceContractModel } from "./DeviceContractModel";
import { DeviceTypeModel } from "./DeviceTypeModel";
import { ServiceModel } from "./ServiceModel";
import { UserModel } from "./UserModel";

export type DeviceNeedItemModel = {
  id: number;
  deviceNeedId: number;
  deviceNeed?: DeviceRequestModel | null;
  categoryId: number;
  category?: DeviceCategoryModel | null;
  deviceTypeId: number;
  deviceType?: DeviceTypeModel | null;
  deviceId?: number | null;
  device?: object | null;
  status: string;
  isReplacement: string;
  replacementDeviceNeedId?: number | null;
  replacementDeviceNeed?: DeviceRequestModel | null;
  updatedBy?: string | null;
  updatedByUser?: UserModel | null;
  createdAt: string;
  updatedAt: string;
};

export type DeviceRequestModel = {
  id: number;
  serviceCode: string;
  service?: ServiceModel | null;
  partnerCode: number;
  partner?: object | null;
  deliveryAddressCode: number;
  deliveryAddress?: DeliveryAddressModel | null;
  isActive: string;
  updatedBy?: string | null;
  updatedByUser?: UserModel | null;
  createdAt: string;
  updatedAt: string;
  items?: DeviceNeedItemModel[] | null;
  //extended/compat fields (may come from API in flattened form)
  status?: string | null;
  createdBy?: string | null;
  createdByUser?: UserModel | null;
  deviceType?: DeviceTypeModel | null;
  deviceCode?: number | null;
  device?: object | null;
  isReplacementNeed?: "I" | "N" | null;
  deviceContract?: DeviceContractModel | null;
  //casted
  partnerName?: string | null;
  seat?: string | null;
  fullAddress?: string | null;
  deviceTypeName?: string | null;
  deviceCategoryName?: string | null;
  createdAtDate?: string | null;
};

export type DeviceRequestTableKey = {
  label: string;
  key: string;
  align?: "inherit" | "left" | "right" | "center" | "justify" | null;
};

export const tableKeys: DeviceRequestTableKey[] = [
  { label: "Ügyfél neve", key: "partnerName" },
  { label: "Telephely neve", key: "seat" },
  { label: "Telephely címe", key: "fullAddress" },
  { label: "Eszköz típusa", key: "deviceTypeName" },
  { label: "Igénylés ideje", key: "createdAtDate" },
];

export const getDeviceRequestStatusName: (status: string) => string = (status: string): string => {
  switch (status) {
    case "U":
      return "Új";
    case "E":
      return "Elfogadott";
    case "C":
      return "Csere";
    case "K":
      return "Kihelyezett";
    case "X":
      return "Törölt";
    default:
      return "Nincs megadva";
  }
};
